// src/components/sections/SolutionsSection.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import solutionbg from "../../assets/background/solutionbg.png";
import SolutionCard from "../common/SolutionCard";

export default function SolutionsSection() {
  const { t } = useTranslation();

  return (
    <section
      id="solutions"
      className="
        relative isolate text-white
        bg-cover bg-center bg-no-repeat
        px-4 py-36 mobile:py-10 tabletair:py-16 tabletmini:py-16
      "
      style={{
        backgroundImage: `url(${solutionbg})`,
      }}
    >
      <div className="max-w-[1400px] mx-auto flex flex-col gap-[48px] mobile:px-4">
        <div className="flex flex-col gap-[16px] mx-auto">
          {/* Caption */}
          <p className="text-center font-medium text-[20px] mobile:text-[14px] font-bold text-brandBlue-500 tracking-wide uppercase">
            {t("solutions.caption", { defaultValue: "GIẢI PHÁP" })}
          </p>

          {/* Headline */}
          <h2 className="text-center font-semibold text-[56px] mobile:text-[24px] tabletpro:text-[56px] tabletair:text-[36px] tabletmini:text-[32px] mobile text-neutral-1 font-md max-w-[900px] mx-auto">
            {t("solutions.headline", {
              defaultValue: "Hệ thống định danh số toàn diện cho kỷ nguyên số",
            })}
          </h2>

          {/* Sub */}
          <p className="text-center text-neutral-5 font-normal max-w-[1030px] tabletpro:max-w-[900px] tabletair:max-w-[760px] mx-auto text-[16px] mobile:text-[16px] tabletpro:text-[16px] tabletair:text-[16px] tabletmini:text-[16px]">
            {t("solutions.sub", {
              defaultValue:
                "Bộ giải pháp định danh số tích hợp SSI, VC, QES và eID Wallet giúp người dùng tự chủ dữ liệu, ký số an toàn, lưu trữ và xác minh danh tính theo các chuẩn quốc tế, sẵn sàng cho dịch vụ số và chính phủ điện tử.",
            })}
          </p>
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-2 items-stretch tabletair:grid-cols-1 tabletmini:grid-cols-1 mobile:grid-cols-1 max-w-[1400px] tabletpro:max-w-[900px] tabletair:max-w-[760px] tabletmini:max-w-[700px] gap-8 mx-auto">
          <SolutionCard
            title={t("solutions.cards.ssi.title")}
            items={t("solutions.cards.ssi.items", { returnObjects: true })}
            borderColors={["#FFFFFF", "#036AE5"]}
          />

          <SolutionCard
            title={t("solutions.cards.vc.title")}
            items={t("solutions.cards.vc.items", { returnObjects: true })}
            borderColors={["#FFFFFF", "#036AE5"]}
          />

          <SolutionCard
            title={t("solutions.cards.qes.title")}
            items={t("solutions.cards.qes.items", { returnObjects: true })}
            borderColors={["#036AE5", "#FFFFFF"]}
          />

          <SolutionCard
            title={t("solutions.cards.wallet.title")}
            items={t("solutions.cards.wallet.items", { returnObjects: true })}
            borderColors={["#036AE5", "#FFFFFF"]}
          />
        </div>
      </div>
    </section>
  );
}
